module.exports = __webpack_public_path__ + "img/Loginicon.b85e37a1.svg";